export default __webpack_public_path__ + "static/4-76a0076b464335df62a1784aab848bb8.png";